<div class="grid p-fluid flex-row-reverse dashboard-graph-grid">
  <div class="col-12">
    <p-card>
      <ng-template #header>
        <div class="m-4 mb-0 p-card-title flex flex-row justify-content-between">
          <strong>Utenti</strong>
          <app-action-button type="add" label="Aggiungi" (click)="addUser()"></app-action-button>
        </div>

      </ng-template>
      <p-table #table styleClass="p-datatable p-datatable-striped p-datatable-sm p-datatable-gridlines"
               [lazy]="false" [value]="users"
               [rows]="200"
               [rowsPerPageOptions]="[20, 50, 100, 150, 200]"
               [totalRecords]="users.length"
               [paginator]="true"
               [rowHover]="true"
               [loading]="loading"
               [autoLayout]="true"
               responsiveLayout="stack"
      >
        <ng-template pTemplate="header">
          <tr>
            <th>Username</th>
            <th>Email</th>
            <th>Nome</th>
            <th>Cognome</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
          <tr>
            <td>
              <div class="flex flex-row align-items-center">
                <p-button variant="text" (click)="editUser(item)">
                  <i class="pi pi-pencil"></i>
                </p-button>
                <p [class.disabled]="!obj(item).active">
                  {{ obj(item).username }}
                  <span *ngIf="!obj(item).active" class="ml-3">[UTENTE DISABILITATO]</span>
                </p>
              </div>
            </td>
            <td [class.disabled]="!obj(item).active">{{ obj(item).mail }}</td>
            <td [class.disabled]="!obj(item).active">{{ obj(item).name }}</td>
            <td [class.disabled]="!obj(item).active">{{ obj(item).surname }}</td>
          </tr>
        </ng-template>
      </p-table>
    </p-card>
  </div>
</div>
